import { apiRequest } from "./axiosInstance";


export const getCompany = async (params)=>{
    const response = await apiRequest({
        url: "/company/getCompanies",
        method: "GET",
        params:params
      });
      return response?.data
}


export const createCompany = async (body) => {
  try {
    // let data= await axios.post(`${baseUrl}/user/createUser`,userdata)

    const data = await apiRequest({
      url: "/company/createCompany",
      method: "POST",
      data: body,
    });
    return {sucess:true,message:data?.data};
  } catch (error) {
    console.log(error, "error");
    return {message:error?.response?.data?.message,sucess:false};
  }
};